<template xmlns="http://www.w3.org/1999/html">
  <b-modal size="xl" v-model="show" centered :title="'Tour beplanen'"
  >
    <b-row class="mt-2">
      <b-col md="2" class="my-auto">
        <span>Tourname</span>
      </b-col>
      <b-col>
        <b-form-input class="form-control text-black"
                      v-model="tour_int.gi_auf_ext"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2" class="my-auto">
        <span>Beschreibung</span>
      </b-col>
      <b-col>
        <b-form-textarea class="text-black"
                         style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                         rows="4"
                         no-resize
                         wrap="hard"
                         v-model="tour_int.gi_memo"

        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2" class="my-auto">
        <span>{{tour_int.is_single_stamm ? 'Stammauftrag' : 'Auftrag: An- und Abfahrt'}}</span>
      </b-col>
      <b-col>
        <b-input-group @click="onChangeAufisn">
          <template #append>
            <edit-icon @click="onChangeAufisn" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
          </template>
          <b-form-input class="form-control text-black"
                        v-model="startEndAuftrag.object"
                        disabled
          ></b-form-input>
        </b-input-group>
        <b-form-text v-if="!tour_int.is_single_stamm">Wird für die Anfahrt zum ersten und Abfahrt vom letzten Objekt verwendet. (Optional)</b-form-text>
        <b-form-text v-else>Für die Zeiterfassung wird dieser Auftrag verwendet.</b-form-text>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2" class="my-auto">
        <span>Fahrzeuge</span>
      </b-col>
      <b-col>
        <b-input-group @click="showFahrModal">
          <template #append>
            <edit-icon @click="showFahrModal" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
          </template>
          <b-form-tags
              v-model="formateFahrs"
              tag-variant="secondary"
              tag-pills
              size="lg"
              disabled
              placeholder=""
              wrap="hard"
              max-rows="2"
          ></b-form-tags>
        </b-input-group>
        <b-form-text>Vorauswahl von Fahrzeugen. (Optional)</b-form-text>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col class="my-auto">
        <span style="text-decoration: underline"><b>Planung</b></span>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-row>
          <b-col md="4" class="my-auto">
            <span>Leistungsgr.</span>
          </b-col>
          <b-col>
            <b-input-group @click="onChangeLegr">
              <template #append>
                <edit-icon @click="onChangeLegr" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
              </template>
              <b-form-input class="form-control text-black"
                            :style="tour_int.legr === '' ? 'border-color: red; cursor: pointer;' : 'cursor: pointer;'"
                            v-model="legrName"
                            disabled
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="4" class="my-auto">
            <b-form-checkbox switch v-model="task_series_enabled">
              Serienaufgabe
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-input-group>
              <template #append v-if="task_series_enabled">
                <edit-icon @click="$refs.create_task_series_dialog.showModal()" title="" v-tooltip="'Anpassen'"
                           class="icon-1_5x" fillColor="#2463ea"
                           style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;"
                           :size="72"></edit-icon>
              </template>
              <b-form-input class="form-control text-black"
                            v-model="taskSeriesTitle"
                            disabled
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4" class="my-auto">
            <span>Zieldatum</span>
          </b-col>
          <b-col>
            <datetime
                style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"

                v-model="tour_int.ziel_datum"
                input-class="form-control"
                :input-style="tour_int.ziel_datum === null || tour_int.ziel_datum === '' ? 'border-color: red;' : 'color: black;'"
                input-id="date"
                :aria-placeholder="formateDate"
                :phrases="datetimeConfig.phrases"
                :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                :min-datetime="datetimeConfig.minTime"></datetime>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="4" class="my-auto">
            <span>Fertigstellungsart</span>
          </b-col>
          <b-col>
            <b-form-select :options="close_automatic_select" id="close_automatic" :plain="true"
                           v-model="close_automatic"
                           class="mb-2 text-black"></b-form-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col class="my-auto">
        <span>Verantwortlich / Abrechnend</span>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="8" class="my-auto">
            <span>Ausführend: Mitarbeiter / Gruppen</span>
          </b-col>

          <b-col md="4">
            <b-row style="flex-direction: row-reverse; margin-right: 8px">
              <minus-icon title="" v-tooltip="'Entfernen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="onDeletePlanning"></minus-icon>
              <plus-icon title="" v-tooltip="'Hinzufügen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$emit('select-planning', users)"></plus-icon>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2"></b-col>
      <b-col md="4">
        <v-jstree ref="js_tree" :allow-transition="false"
                  :style="selectedKostMigr === null ? 'flex: 1 0; border: 1px solid red; border-radius: 0.25rem;' : 'flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;'"
                  class="my-tree" :data="kostMigrs"
                  @item-click="onItemClicked"
                  show-checkbox></v-jstree>
      </b-col>
      <b-col md="6">
        <b-table striped hover selectable :items="selectedPlannings" :fields="planningFields"
                 select-mode="single"
                 selectedVariant="primary"
                 ref="group_table"
                 @row-selected="onRowSelected"
        >
          <template v-slot:cell(memo)="data" >
            <div style="display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;">{{data.item.memo}}</div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinueTour" variant="success" @click="onCreate">
        {{'Anlegen'}}
      </b-button>
    </template>

    <select-aufisn-dialog ref="select_aufisn" @aufisn-selected="onAufisnChanged"></select-aufisn-dialog>
    <create-task-series-dialog ref="create_task_series_dialog" :task-date="tour_int.ziel_datum"
                               @create-task-series="createTaskSeries"/>
    <b-modal size="md" v-model="showSelectFahrs" centered title="Fahrzeuge wählen"
    >
      <b-row>
        <b-col style="height: 55vh; overflow: auto">
          <b-table thead-class="display_none" striped hover selectable :items="fahrs" :fields="fahr_fields"
                   select-mode="multi"
                   selectedVariant="primary"
                   ref="fahr_table"
          >
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showSelectFahrs = false">
          Abbrechen
        </b-button>
        <b-button size="md" variant="success" @click="onFahrsSelected">
          Annehmen
        </b-button>
      </template>
    </b-modal>
  </b-modal>

</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";
import {Server_URL} from "@/shared/utils";
import EditIcon from 'vue-material-design-icons/PencilCircle.vue';
import PencilPlusIcon from 'vue-material-design-icons/PencilPlus.vue';
import PlusIcon from 'vue-material-design-icons/PlusCircle.vue';
import MinusIcon from 'vue-material-design-icons/MinusCircle.vue';
import VJstree from 'vue-jstree'
import {v4} from "uuid";
import {parseTimestamp} from "@/shared/dates";
import SelectAufisnDialog from "@/views/aufgaben_verwaltung/SelectAufisnDialog.vue";
import CreateTaskSeriesDialog from "@/views/aufgaben_verwaltung/CreateTaskSeriesDialog.vue";

import {decryptAES, encryptAES} from "@/shared/crypto";




export default {
  name: "PlanTourDialog",
  components: {
    EditIcon,
    PencilPlusIcon,
    PlusIcon,
    MinusIcon,
    VJstree,
    SelectAufisnDialog,
    CreateTaskSeriesDialog
  },
  props:{
    legrs: {
      type: Array,
      default: () => []
    },
    bauhofStructure: {
      type: Array,
      default: () => []
    },
    groups: {
      type: Array,
      default: () => []
    },
    objectsMap: {
      type: Object,
      default: () => {}
    },
    fahrs: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    canContinueTour() {
      return this.selectedKostMigr !== null
          && this.tour_int.ziel_datum !== null && this.tour_int.ziel_datum !== ""
          && this.tour_int.legr !== "";
    },
    tourDate() {
      return this.tour_int.ziel_datum;
    },
    legrName() {
      if (this.tour_int.legr === '') {
        return 'Leistungsgruppe wählen';
      } else {
        for (let i = 0; i < this.legrs.length; i++) {
          if (this.legrs[i].id === this.tour_int.legr) {
            return this.legrs[i].name;
          }
        }
      }
      return '';
    },
    formateFahrs: {
      get(){
        let res = [];
        if(this.tour_int.vehicles && this.tour_int.vehicles.length) {
          for (let i = 0; i < this.tour_int.vehicles.length; i++) {
            for (let j = 0; j < this.fahrs.length; j++) {
              if (this.fahrs[j].access === this.tour_int.vehicles[i]) {
                res.push(this.fahrs[j].name);
                break;
              }
            }
          }
        }
        return res;
      },
      set(newVal){
        let res = [];
        if(this.tour_int.vehicles && this.tour_int.vehicles.length) {
          for (let i = 0; i < this.tour_int.vehicles.length; i++) {
            for (let j = 0; j < this.fahrs.length; j++) {
              if (this.fahrs[j].access === this.tour_int.vehicles[i]) {
                res.push(this.fahrs[j].name);
                break;
              }
            }
          }
        }
        return res;
      }
    },
    taskSeriesTitle() {
      if (!this.task_series) {
        return this.task_series_enabled ? "Bitte definieren ->" : "Keine Wiederholung"
      } else {
        switch (this.task_series.series_type) {
          case "Y":
            return "Jährliche Wiederholung";
          case "M":
            return "Monatliche Wiederholung";
          case "W":
            return "Wöchentliche Wiederholung";
        }
      }
      return "";
    },
  },
  data: () => {
    return {
      show: false,
      tour_int: {
        ziel: null,
        ziel_datum: null,
        gi_auf_ext: "",
        gi_memo: "",
        legr: "",
        vehicles: [],
      },
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      status: -1,
      s_select: [{text: "", value: -1}, {text: "10 Monate", value: 10}, {text: "3 Monate", value: 3}, {text: "1 Monat", value: 1}, {text: "1 Woche", value: 0.25}, {text: "sofort", value: 0}],
      close_automatic: false,
      close_automatic_select: [{text: "Manuelle Fertigstellung", value: false}, {text: "Automatische Fertigstellung", value: true}],
      gelegentlich: false,
      kostMigrs : [],
      selectedKostMigr: null,
      users: [],
      selectedPlannings: [],
      currentPlanning: null,
      startEndAuftrag: {
        id: "",
        object: "",
        augr: "",
        aufisn: "",
      },
      planningFields: [{key: "name", label: 'Name'}],
      task_series_enabled: false,
      task_series: null,
      showSelectFahrs: false,
      fahr_fields: [{key: "name", label: 'Fahrzeugname'}],

    }
  },
  watch: {
    task_series_enabled(n, o) {
      if (!n) {
        this.task_series = null;
      } else {
        this.$refs.create_task_series_dialog.showModal();
      }
    },
    bauhofStructure(n, o) {
      if (!n || !n.length) {
        return;
      }
      this.kostMigrs = this.computeKostMigrs(JSON.parse(JSON.stringify(n)));
      this.users = JSON.parse(JSON.stringify(n));
      this.computeMitas(this.users);
    },
    status(n, o) {
      if (n === -1) {
        this.tour_int.ziel_datum = null;
        return;
      }
      if (n === 0) {
        this.tour_int.ziel_datum = new Date().toISOString();
      } else if (n === 0.25) {
        let d = new Date();
        d.setDate(d.getDate() + 7);
        this.tour_int.ziel_datum = d.toISOString();
      } else {
        let d = new Date();
        d.setMonth(d.getMonth() + n);
        this.tour_int.ziel_datum = d.toISOString();
      }
    },
    tourDate(n, o) {
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (!this.selectedPlannings[i].dueDate) {
          this.selectedPlannings[i].dueDate = n;
        }
      }
    }
  },
  methods: {
    calculateFirstSeriesDate(taskSeries) {
      let date = null;
      if (taskSeries.series_type === 'Y') {
        date = this.calculateNextYearlyDate(taskSeries);
      } else if (taskSeries.series_type === 'M') {
        date = this.calculateNextMonthlyDate(taskSeries);
      } else if (taskSeries.series_type === 'W') {
        date = this.calculateNextWeeklyDate(taskSeries);
      }
      if (date !== null) {
        this.tour_int.ziel_datum = date.toISOString();
      }
    },
    calculateNextYearlyDate(taskSeries) {
      let today = new Date();
      let nextDate = null;
      if (taskSeries.day !== -1) {
        nextDate = new Date(today.getFullYear(), taskSeries.month - 1, taskSeries.day, 12);
      } else {
        nextDate = new Date(today.getFullYear(), taskSeries.month - 1, 1, 12);
        nextDate.setDate(nextDate.getDate() + (taskSeries.weekday - nextDate.getDay() + 7) % 7 + 7 * (taskSeries.week - 1));
      }
      today.setHours(0, 1)
      if (nextDate < today) {
        nextDate.setFullYear(nextDate.getFullYear() + 1);
      }
      return nextDate;
    },
    calculateNextMonthlyDate(taskSeries) {
      let today = new Date();
      let months = taskSeries.months.split(",");
      for (let i = 0; i < months.length; i++) {
        months[i] = parseInt(months[i])-1;
      }
      // order the months
      months.sort((a, b) => a - b);
      if (months.length === 0) {
        return null;
      }
      let nextDate = null;
      let yearAddition = 0;
      while (true) {
        for (let i = 0; i < months.length; i++) {
          if (taskSeries.day !== -1) {
            nextDate = new Date(
                today.getFullYear() + yearAddition,
                months[i],
                this.getNormalizedDay(today.getFullYear() + yearAddition, months[i], taskSeries.day),
                12);
          } else {
            nextDate = new Date(
                today.getFullYear() + yearAddition,
                months[i],
                1,
                12);
            nextDate.setDate(nextDate.getDate() + (taskSeries.weekday - nextDate.getDay() + 7) % 7 + 7 * (taskSeries.week - 1));
          }
          if (nextDate >= today) {
            return nextDate;
          }
        }
        yearAddition++;
      }
    },
    getNormalizedDay(year, month, day) {
      let day2 = 32 - new Date(year, month, 32).getDate();
      if (day < day2) {
        return day;
      }
      return day2;
    },
    calculateNextWeeklyDate(taskSeries) {
      let nextDate = new Date();
      let months = taskSeries.months.split(",");
      for (let i = 0; i < months.length; i++) {
        months[i] = parseInt(months[i])-1;
      }
      // order the months
      months.sort((a, b) => a - b);
      if (months.length === 0) {
        return null;
      }
      nextDate.setDate(nextDate.getDate() + (taskSeries.weekday - nextDate.getDay() + 7) % 7);
      while (!this.isInMonths(nextDate, months)) {
        nextDate.setDate(nextDate.getDate() + 7);
      }
      return nextDate;
    },
    isInMonths(date, months) {
      let month = date.getMonth();
      return months.includes(month);
    },
    showFahrModal() {
      this.showSelectFahrs = true;
      this.$nextTick(() => {
        this.$refs.fahr_table.clearSelected();
        for (let i = 0; i < this.fahrs.length; i++) {
          for (let j = 0; j < this.tour_int.vehicles.length; j++) {
            if (this.fahrs[i].access === this.tour_int.vehicles[j]) {
              this.$refs.fahr_table.selectRow(i);
              break;
            }
          }
        }
      });
    },
    onFahrsSelected() {
      this.tour_int.vehicles = [];
      for (let i = 0; i < this.fahrs.length; i++) {
        if (this.$refs.fahr_table.isRowSelected(i)) {
          this.tour_int.vehicles.push(this.fahrs[i].access);
        }
      }
      this.showSelectFahrs = false;
    },
    createTaskSeries(payload) {
      this.task_series = payload;
      this.calculateFirstSeriesDate(this.task_series);
    },
    onAufisnChanged({selected_aufisn}) {
      this.startEndAuftrag = selected_aufisn;
    },
    onChangeAufisn() {
      this.$refs.select_aufisn.showDialog(this.groups, this.objectsMap);
    },
    getReturnData() {
      let p = [];
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        p.push(this.selectedPlannings[i].id);
      }
      if (this.task_series) {
        this.task_series.close_automatic = this.close_automatic;
        this.task_series.default_allocation = p.join(",");
      }
      let res = {
        tour_name: this.tour_int.gi_auf_ext,
        tour_description: this.tour_int.gi_memo,
        tour_date: this.tour_int.ziel_datum,
        tour_legr: this.tour_int.legr,
        tour_vehicles: this.tour_int.vehicles,
        kost_migr: this.selectedKostMigr.id,
        close_automatic: this.close_automatic,
        aufisn: this.startEndAuftrag.aufisn,
        augr: this.startEndAuftrag.augr,
        allocation: p,
        task_series: this.task_series,
        is_single_stamm: this.tour_int.is_single_stamm,
      }
      return res;
    },
    formateDueDate(value) {
      if (!value) {
        return ""
      } else {
        return parseTimestamp(new Date(Date.parse(value)), 'DD.MM.YYYY');
      }
    },
    onRowSelected(data) {
      if (data.length) {
        this.currentPlanning = data[0];
      } else {
        this.currentPlanning = null;
      }
    },
    onNewPlanning(selected) {
      console.log(selected);
      for (let i = 0; i < selected.length; i++) {
        let cur = selected[i];
        cur._id = v4();
        cur.memo = this.tour_int.gi_memo;
        cur.dueDate = this.tour_int.ziel_datum;
        this.selectedPlannings.push(cur);
      }
    },
    onDeletePlanning() {
      if (!this.currentPlanning) {
        return;
      }
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === this.currentPlanning._id) {
          this.selectedPlannings.splice(i, 1);
        }
      }
      this.currentPlanning = null;
    },
    onItemClicked(node, item, e) {
      this.selectedKostMigr = item;
    },
    async onCreate() {
      let data = this.getReturnData();

      this.$emit('plan-tour', data);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onShow(t) {
      this.tour_int.gi_auf_ext = t.name;
      this.tour_int.gi_memo = t.description;
      this.tour_int.legr = t.legr;
      this.tour_int.vehicles = [...t.vehicles];
      this.tour_int.is_single_stamm = t.is_single_stamm;
      this.tour_int.standard_task = t.standard_task;
      if (this.tour_int.is_single_stamm && this.tour_int.standard_task) {
        for (const valueKey in this.objectsMap) {
          if (this.objectsMap[valueKey].length) {
            for (let i = 0; i < this.objectsMap[valueKey].length; i++) {
              if (this.objectsMap[valueKey][i].id === this.tour_int.standard_task) {
                this.startEndAuftrag = this.objectsMap[valueKey][i];
              }
            }
          }
        }
      }
      this.show = true;
    },
    formateDate() {
      if (this.tour_int.ziel_datum === null) {
        return ""
      }
      let event = new Date(this.tour_int.ziel_datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    onChangeLegr() {
      this.$emit("select-legr");
    },
    onSetLegr(id) {
      this.tour_int.legr = id;
    },
    computeKostMigrs(data) {
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    onChangeTodo(data) {
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === data._id) {
          this.selectedPlannings[i] = data;
          this.selectedPlannings = [...this.selectedPlannings]
        }
      }
      this.currentPlanning = null;
    }
  },
}
</script>

<style>
.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}
</style>

<style scoped>

.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}

</style>
